// UROP projects on the website will be listed in the order in which they are listed in the uropProjects array

import { UropProjects } from '../../types';

// import project objects
import humanoid_perception from './01.humanoid_perception/article';

export const uropProjects: UropProjects = [
  humanoid_perception,
];
